import Appointments from './Appointments';

export default Appointments;
